import type * as React from 'react'

export function Layout({
  children,
  imageSrc,
  imageAlt,
}: {
  children: React.ReactNode
  imageSrc: string
  imageAlt: string
}) {
  return (
    <main className="flex pt-24 lg:pt-0">
      <section className="w-full p-6 lg:w-1/2 lg:px-24 lg:py-28">
        <div className="m-auto lg:max-w-[500px]">{children}</div>
      </section>
      <div className="hidden lg:block">
        <aside className="fixed bottom-0 left-auto right-0 top-0 w-1/2">
          <img
            className="h-full w-full object-cover"
            src={imageSrc}
            alt={imageAlt}
          />
        </aside>
      </div>
    </main>
  )
}
